export function scrollGnavEvent() {
    window.addEventListener('scroll', function () {
        const scrollValue = window.pageYOffset;
        const svg = document.querySelectorAll('.js-change-color');
        if (scrollValue > 100) {
            svg.forEach(function (svg) {
                svg.classList.add('u-js-gray');
            });
        }
        if (scrollValue < 100) {
            svg.forEach(function (svg) {
                svg.classList.remove('u-js-gray');
            });
        }
    });
}
